import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import NoteForm from '../components/note/form/NoteFrom';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageNavigateTitle from '../components/shared/page/PageNavigateTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';
import useFetchNote from '../hooks/notes/useFetchNote';

const Note = () => {
  const { noteId } = useParams();
  const userData = useSelector((state) => state.auth?.userData);
  const { loading, note } = useFetchNote(noteId);

  const isOwner = note && userData && note.userId === userData.id;
  const readOnly = !isOwner;

  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <div className="flex items-center gap-2">
            <PageNavigateTitle title={note?.title || 'Нотатка'} link={'/notes'} />
          </div>
        </PageTitleContainer>
        {loading ? <CommonLoader /> : note && <NoteForm note={note} readOnly={readOnly} />}
      </section>
    </Suspense>
  );
};

export default Note;
